import { twMerge } from "tailwind-merge";

import { DecryptedText } from "shared/ui/decrypted-text";

import galacticaNetwork from "./assets/galactica-com.svg";
import passportBgPng from "./assets/passport-bg.png";
import { Star } from "./star";

type Props = {
  className?: string;
};

export const Passport = (props: Props) => {
  const { className } = props;
  return (
    <div className="relative h-1 w-full pb-[120%]">
      <div
        className={twMerge(
          "absolute inset-0",
          "border-mercury flex shrink-0 grow flex-col items-center justify-center rounded-3xl border bg-cover bg-center py-12",
          className
        )}
        style={{
          backgroundImage: `url(${passportBgPng})`,
        }}
      >
        <h2 className="font-ptm mb-2.5 text-center text-3xl leading-[130%] uppercase">
          <DecryptedText
            speed={100}
            text="Passport"
            animateOn="view"
            revealDirection="center"
          />
        </h2>
        <Star />

        <img src={galacticaNetwork} alt="Galactica" />
      </div>
    </div>
  );
};
